<ion-button [disabled]="isDisable" class="{{ 'bh-button-' + theme }}" expand="block">
    <ng-content></ng-content>
</ion-button>
